import { getUiPictureData } from '@academica-box/helpers/getUiPictureData'
import type { Price } from '@academica-box/components/Cards/UiProductCard/types'
import { pluralize } from '@academica-box/utils/scripts/pluralize'
import type { ActiveSubscription } from '@academica-box/swagger/academgen'
import type { MappedLanding } from '@academica-box/api/courses'
import type { PaymentData } from '@/helpers/mappingCourseData'

const getPrice = (activeSubscription: ActiveSubscription, hasSubcribe: boolean): Price => {
  return {
    current: activeSubscription.is_trial && !hasSubcribe ? activeSubscription.trial_price || 0 : activeSubscription.base_price || 0,
    currency: '₽',
  }
}

export const getSubscriptionData = (
  landing: MappedLanding,
  activeSubscription: ActiveSubscription,
  hasSubcribe: boolean,
  subscriptionCoursesCount: number,
): PaymentData => {
  if (!landing || !activeSubscription) {
    return
  }

  const isTrialPro = activeSubscription.is_trial
  let description = 'Каждые 30&nbsp;дней<br> с&nbsp;момента оплаты'

  if (isTrialPro && !hasSubcribe) {
    description = `за&nbsp;${activeSubscription.trial_period}&nbsp;${pluralize(activeSubscription.trial_period || 0, ['день', 'дня', 'дней'])} пробного периода.<br> Далее ${activeSubscription.base_price}&nbsp;₽ каждые 30&nbsp;дней`
  }

  return {
    data: {
      title: 'Подписка Академика Pro',
      descriptions: [
        `Быстрый доступ сразу к&nbsp;${subscriptionCoursesCount}+ курсам`,
        'Экономия времени и&nbsp;максимум пользы',
        'Оплата один раз в&nbsp;месяц и&nbsp;отмена в&nbsp;любой момент',
      ],
      price: getPrice(activeSubscription, hasSubcribe),
      trialPro: true,
    },
    priceBanner: {
      images: getUiPictureData({
        sm: [
          'https://cdn.skillbox.pro/wbd-front/academica-static/general/autopayment/subscribe-pro-price-banner-new@1x.avif',
          'https://cdn.skillbox.pro/wbd-front/academica-static/general/autopayment/subscribe-pro-price-banner-new@1x.webp',
          'https://cdn.skillbox.pro/wbd-front/academica-static/general/autopayment/subscribe-pro-price-banner-new@1x.png'
        ]
      }),
      bgColor: 'linear-gradient(283deg, #d6b7fd -0.8%, #c3ddfd 13.58%, rgba(243, 234, 255, 1) 54.43%, #c3ddfd 88.26%, #d6b7fd 105.25%)',
      description,
    },
  }
}
